<template>
  <!-- 売上情報 -->
  <div id="RecordSalesDetail">
    <div id="item-contens">
      <div class="card-content margin-top">
        <table>
          <tr><th class="th">受付番号</th><td class="td">{{salesInfo.receiptNumber}} </td></tr>
          <tr><th class="th">得意先コード</th><td class="td">{{salesInfo.customerCode}}</td></tr>
          <tr><th class="th">得意先名称</th><td class="td">{{salesInfo.customerName}}</td></tr>
          <tr>
            <th class="th">営業所コード</th>
            <td class="td">
              {{salesInfo.salesOfficeCode}}
            </td>
          </tr>
          <tr>
            <th class="th">営業員コード</th>
            <td class="td">
              {{salesInfo.salesStaffCode}}
            </td>
          </tr>
          <template v-if="isKenshin">
            <tr><th class="th">品目コード</th>
              <td v-if="type == 'edit'" class="td"><input type="text" v-model="salesInfo.itemCode" maxlength="20"/></td>
              <td v-else class="td">{{salesInfo.itemCode}}</td>
            </tr>
            <tr><th class="th">見積コード</th>
              <td v-if="type == 'edit'" class="td"><input type="text" v-model="salesInfo.estimateCode" maxlength="20"/></td>
              <td v-else class="td">{{salesInfo.estimateCode}}</td>
            </tr>
            <tr><th class="th">申込み件数</th>
              <td class="td"><span v-if="salesInfo.requestCount">{{salesInfo.requestCount}} 件</span></td>
            </tr>
            <tr><th class="th">完了件数</th>
              <td class="td"><span v-if="salesInfo.completeCount">{{salesInfo.completeCount}} 件</span></td>
            </tr>
            <tr><th class="th">キャンセル件数</th>
              <td class="td"><span v-if="salesInfo.cancelCount">{{salesInfo.cancelCount}} 件</span></td>
            </tr>
          </template>
          <template v-else>
            <tr><th class="th">出荷日</th><td class="td">{{salesInfo.shippingDate}}</td></tr>
            <tr><th class="th">品目コード</th>
              <td v-if="type == 'edit' " class="td"><input type="text" v-model="salesInfo.itemCode" maxlength="20"/></td>
              <td v-else class="td">{{salesInfo.itemCode}}</td>
            </tr>
            <tr><th class="th">見積コード</th>
              <td v-if="type == 'edit'"  class="td"><input type="text" v-model="salesInfo.estimateCode" maxlength="20"/></td>
              <td v-else class="td">{{salesInfo.estimateCode}}</td>
            </tr>
            <tr><th class="th">医療機関/企業名</th><td class="td">{{salesInfo.hospital}}</td></tr>
            <tr><th class="th">患者氏名</th><td class="td">{{salesInfo.patientName}}</td></tr>
            <tr><th class="th">検査日</th><td class="td">{{salesInfo.inspectionDate}}</td></tr>
          </template>
        </table>
      </div>
      <div class="button-area">
          <b-button v-if="type == 'edit'" class="is-primary" @click="update">更新</b-button>
          <b-button v-if="type == 'sales'" class="is-primary" @click="recordSales">売上済みにする</b-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RecordSalesDetail",
  props: {
    salesInfo:{},
    type:{},
    isKenshin:{}
  },
  methods: {
      recordSales: function(){
        this.$dialog.confirm({
          title: "　",
          confirmText:"OK",
          cancelText: "キャンセル",
          message:
            "売上計上済みにしますか？",
          cancelConfirm: () => {
            return;
          },
          onConfirm: () => {
              let _this = this;
              //ステータス変更処理
              this.apiCall(
                function(client){
                  return client.apis.internalRequestSearch.updateRecordSalesPOST({
                    body:{
                        kind: _this.salesInfo.kind,
                        receiptNumber: _this.salesInfo.receiptNumber,
                      }
                  });
                },
                function(result) {
                  _this.showSuccess(result);
                  _this.$emit("recordSales");
                },
                function(result) {
                  _this.showErrorMessage(result);
                }
              );
          }
        });
      },
      update: function(){
        let _this = this;
        // Web Api Call
        this.apiCall(
          function(client){
            return client.apis.internalRequestSearch.setRecordSalesInfoPOST({
              body:{
                  kind: _this.salesInfo.kind,
                  receiptNumber: _this.salesInfo.receiptNumber,
                  itemCode: _this.salesInfo.itemCode,
                  estimateCode: _this.salesInfo.estimateCode,
                }
            });
          },
          function(result) {
            _this.estimateCodeOrg = _this.salesInfo.estimateCode
            _this.itemCodeOrg = _this.salesInfo.itemCode
            _this.showSuccess(result);
          },
          function(result) {
            _this.showErrorMessage(result);
          }
        );
      }
  },
  data() {
    return {
      estimateCodeOrg:"",
      itemCodeOrg:""
    };
  },
  filters: {},
  components: {},
  mounted: function() {
    this.estimateCodeOrg = this.salesInfo.estimateCode;
    this.itemCodeOrg = this.salesInfo.itemCode;
  },
  destroyed: function() {
    // 更新されていない場合は値をもとに戻す
    this.salesInfo.estimateCode = this.estimateCodeOrg;
    this.salesInfo.itemCode = this.itemCodeOrg;
  }
};
</script>
<style lang="scss" scoped>
.th {
  width: 150px !important;
}
.td {
  width: 200px !important;
  word-break: break-all ;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/common/RecordSalesDetail.vue